<template>
  <div>
    <div class="wuliu_name" v-if="traceShip.ship_sn != ''">
      <p>快递公司：{{traceShip.ship_name}}</p>
      <p>快递单号：{{traceShip.ship_sn}}</p>
    </div>
    <div class="wuliu_con">
      <div>
        <van-steps direction="vertical" :active="0">
          <van-step v-for="item in traceCon" :key="item.key">
            <h3>{{item.desc}}</h3>
            <p>{{item.time}}</p>
          </van-step>
        </van-steps>
      </div>
    </div>

    <mloading v-if="showLoading"></mloading>
  </div>
</template>
<script>
import { sendRequest } from '@/assets/public'
import { Dialog, Toast } from 'vant'
import mloading from '@/components/loading.vue'
export default {
  components: { mloading },
  data() {
    return {
      order_id: '',
      traceCon: [],
      traceShip: {},
      showLoading: true,
    }
  },
  mounted() {
    this.order_id = this.$route.query.xh_id
    this.ship_sn=this.$route.query.ship_sn
    this.trace()
  },
  methods: {
    async trace() {
      this.showLoading = true
      let { content, status, msg } = await sendRequest('order/trace', {
        order_id: this.order_id,
        ship_sn:this.ship_sn
      })
      if (status == '200') {
        this.showLoading = false
        this.traceCon = content.list
        this.traceShip = content
      } else {
        this.showLoading = false
        Toast(msg)
      }
    },
  },
}
</script>
<style scoped>
.wuliu_name {
  background: #fff;
  margin: 0.4rem 0;
  padding: 0.4rem 0.8rem;
}

.wuliu_name p {
  color: #333333;
  font-size: 0.52rem;
  padding: 0.2rem 0;
}

.wuliu_con h3 {
  display: inherit;
  margin-block-start: 0;
  margin-block-end: 0;
  font-size: 0.52rem;
}

.wuliu_con p {
  color: #999999;
  font-size: 0.44rem;
}
</style>